<template>
  <div class="postManage">
    <OACard header="组织内职位" :col="16">
      <el-button
        type="primary"
        plain
        size="medium"
        @click="addAndEdit('edit')"
        :disabled="!checkList.length"
      >编辑</el-button>
      <el-button type="warning" plain size="medium" @click="remove" :disabled="!checkList.length">删除</el-button>
      <el-button type="primary" plain size="medium" class="pull-right" @click="addAndEdit('add')">添加</el-button>
      <d2-crud
        ref="postData"
        :columns="postColumns"
        :data="postData"
        :options="options"
        :loading="postLoading"
        selection-row
        @selection-change="handleSelectionChange"
        :pagination="postPage"
        @pagination-size-change="postSizeChange"
        @pagination-current-change="postCurrentChange"
      ></d2-crud>
    </OACard>
    <OACard header="组织内人员" :col="16" class="pull-right">
      <d2-crud
        ref="personData"
        :columns="personColums"
        :data="personData"
        :options="options"
        :loading="personLoading"
        @cell-data-change="cellDataChange"
        :pagination="personPage"
        @pagination-size-change="personSizeChange"
        @pagination-current-change="personCurrentChange"
      />
    </OACard>
    <OAModalForm
      :title="titleText"
      :visible.sync="dialogVisible"
      :form-data="formData"
      @on-submit="submit"
      @on-cancel="cancel"
    ></OAModalForm>
  </div>
</template>
<script>
import d2Crud from "@d2-projects/d2-crud";
import commonApi from "@/services/common.js";
import organizeApi from "@/services/organize.js";
import OACard from "@/components/OACard/OACard";
import { numabc } from "@/common/reg.js";
import filters from "@/mixins/filters";
import OAModalForm from "@/components/OAModalForm/OAModalForm";
import { resFilter } from "@/common/util.js";
export default {
  name: "organizeManage",
  components: { OACard, OAModalForm, d2Crud },
  props: ["departId"],
  mixins: [filters],
  data() {
    var codePass = (rule, value, callback) => {
      if (new RegExp(numabc).test(value)||value=="") {
        callback();
      } else {
        callback(new Error("请输入正确的职位编号"));
      }
    };
    return {
      titleText: "",
      dialogVisible: false,
      checkList: [],
      type: "",
      options: {
        border: true,
        stripe: true,
        size: "medium"
      },
      postLoading: false,
      postData: [],
      postColumns: [
        {
          title: "职位名称",
          key: "positionName",
          formatter: (row, column, cellValue, index) => {
            return filters.isEmpty(cellValue);
          }
        },
        {
          title: "职位编号",
          key: "code",
          formatter: (row, column, cellValue, index) => {
            return filters.isEmpty(cellValue);
          }
        },
        {
          title: "客保数量",
          key: "protectCount",
          formatter: (row, column, cellValue, index) => {
            return filters.isEmpty(cellValue);
          }
        },
        {
          title: "职位属性",
          key: "attrName",
          formatter: (row, column, cellValue, index) => {
            return filters.isEmpty(cellValue);
          }
        },
        {
          title: "职位等级",
          key: "levelName",
          formatter: (row, column, cellValue, index) => {
            return filters.isEmpty(cellValue);
          }
        }
      ],
      personLoading: false,
      personData: [],
      personColums: [
        {
          title: "姓名",
          key: "name",
          formatter: (row, column, cellValue, index) => {
            return filters.isEmpty(cellValue);
          }
        },
        {
          title: "工号",
          key: "number",
          formatter: (row, column, cellValue, index) => {
            return filters.isEmpty(cellValue);
          }
        },
        {
          title: "职位",
          key: "positionName",
          formatter: (row, column, cellValue, index) => {
            return filters.isEmpty(cellValue);
          }
        },
        {
          title: "设为组长",
          key: "leader",
          component: {
            name: "el-switch"
          }
        }
      ],
      formData: {
        positionName: {
          label: "职位名称：",
          formType: "a-input",
          value: undefined,
          placeholder: "请输入职位名称",
          rules: [
            {
              required: true,
              message: "请输入职位名称",
              trigger: "blur"
            }
          ]
        },
        level: {
          label: "职位等级：",
          formType: "a-select",
          value: undefined,
          code: 124,
          placeholder: "请选择职位等级",
          rules: [
            {
              required: true,
              message: "请选择职位等级",
              trigger: "change"
            }
          ]
        },
        code: {
          label: "职位编号：",
          formType: "a-input",
          value: undefined,
          placeholder: "请输入职位编号",
          rules: [
            {
              validator: codePass,
              trigger: "blur"
            }
          ]
        },
        attributes: {
          label: "职位属性：",
          formType: "a-select",
          value: undefined,
          code: 102,
          placeholder: "请选择职位属性",
          rules: [
            {
              required: true,
              message: "请选择职位属性",
              trigger: "change"
            }
          ]
        },
        protectCount: {
          label: "客保数量：",
          formType: "a-input-number",
          value: 0,
          placeholder: "请输入客保数量"
        }
      },
      postPage: {
        currentPage: 1,
        pageSize: 5,
        total: 0,
        layout: "total,sizes,prev,pager,next",
        pageSizes: [5, 10, 15, 20]
      },
      personPage: {
        currentPage: 1,
        pageSize: 5,
        total: 0,
        layout: "total,sizes,prev,pager,next",
        pageSizes: [5, 10, 15, 20]
      }
    };
  },
  watch: {
    departId: {
      handler: function(val, oldValue) {
        if (val) {
          this.getPersonByDepartId();
          this.getPostByDepartId();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    async getPersonByDepartId() {
      this.personLoading = true;
      let res = await commonApi.getPersonByDepartId({
        departId: this.departId,
        displayLength: this.personPage.pageSize,
        displayStart: this.personPage.currentPage
      });
      this.personData = res.data.data;
      this.personPage.total = res.data.page.totalRecords;
      this.personLoading = false;
    },
    personSizeChange(val) {
      this.personPage.pageSize = val;
      this.getPersonByDepartId();
    },
    personCurrentChange(val) {
      this.personPage.currentPage = val;
      this.getPersonByDepartId();
    },
    async getPostByDepartId() {
      this.postLoading = true;
      let res = await organizeApi.getPostByDepartId({
        departmentId: this.departId,
        displayLength: this.postPage.pageSize,
        displayStart: this.postPage.currentPage
      });
      this.postData = res.data.data;
      this.postPage.total = res.data.page.totalRecords;
      this.postLoading = false;
    },
    postSizeChange(val) {
      this.postPage.pageSize = val;
      this.getPostByDepartId();
    },
    postCurrentChange(val) {
      this.postPage.currentPage = val;
      this.getPostByDepartId();
    },
    handleSelectionChange(selection) {
      this.checkList = selection;
    },
    addAndEdit(type) {
      if (this.departId) {
        this.type = type;
        if (type == "add") {
          this.titleText = "新增职位";
          _.map(this.formData, (item, key) => {
            if (key == "protectCount") {
              item.value = 0;
            } else {
              item.value = undefined;
            }
          });
          this.dialogVisible = true;
        } else {
          this.titleText = "编辑职位";
          if (this.checkList.length > 1) {
            this.$message.warning("不支持批量操作");
          } else {
            this.dialogVisible = true;
            this.setValue();
          }
        }
      } else {
        this.$message.warning("请先选择部门");
      }
    },
    cancel() {
      this.dialogVisible = false;
    },
    async submit(data) {
      let fun, param;
      if (this.type == "add") {
        fun = "addPost";
        param = {
          ...data,
          departmentId: this.departId
        };
      } else if (this.type == "edit") {
        fun = "editPost";
        param = {
          ...data,
          departmentId: this.departId,
          id: this.checkList[0].id
        };
      }
      let res = await organizeApi[fun](param);
      resFilter(res, this.getPostByDepartId());
      this.dialogVisible = false;
    },
    remove() {
      if (this.checkList.length === 0) {
        this.$message.warning("请先选择需要删除的职位");
      } else {
        this.$confirm("此操作将永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(async () => {
            let ids = _.map(this.checkList, item => {
              return item.id;
            });
            let res = await organizeApi.removePost({ ids: ids });
            resFilter(res, this.getPostByDepartId());
          })
          .catch(() => {});
      }
    },
    setValue() {
      let data = this.checkList[0];
      _.each(this.formData, (value, key) => {
        value.value = data[key];
      });
    },
    async cellDataChange(data) {
      if (data) {
        let param = {
          departId: this.departId,
          employeeId: data.row.id,
          isSelect: data.row.leader
        };
        let res = await organizeApi.setLeader(param);
        resFilter(res, this.getPersonByDepartId());
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/personnel/components/postManage.vue